import cn from 'classnames';
import { HTMLAttributes } from 'react';
import styles from './topbar.module.scss';


export function TopbarBrand ({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            className={ cn(styles.brand, className) }
            { ...props }
        />
    );
}
